import React from 'react';
import '../styles/components/success-modal.css';

import SuccessIcon from '../assets/icons/success-icon.svg';

type SuccessModalProps = {
  open: boolean;
  onClose: () => void;
};

const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div style={{ display: 'flex' }}>
      <div className="success-modal-dim"></div>
      <div className="success-modal">
        <div style={{ display: 'flex', padding: '25px', alignItems: 'center' }}>
          <SuccessIcon style={{ marginRight: '15px' }} />
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>You’re all set!</span>
        </div>

        <span style={{ padding: '0 25px' }}>
          There are no additional clients available for import.
        </span>

        <div style={{ padding: '25px', display: 'flex', marginTop: 'auto' }}>
          <button className="success-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
